import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { dropdownValuesService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetScheduleAListMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		primaryAgentId => {
			return dropdownValuesService.getScheduleAList(primaryAgentId);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetScheduleAListMutation;
